import SampleDocuments from './sample-documents';

export default SampleDocuments;
